import http from '@monolith/legacy/services/api/http';
import { captureException } from '@core/plugins/sentry';

export const getFeaturedBrands = async () => {
  return http()
    .get('/api/featured/brands')
    .then((response) => response.data.data)
    .catch((error) => {
      captureException(error);
      return [];
    });
};
